import * as angular from "angular";
import * as moment from "moment";
import * as Consts from "../ts/rlAdmin.consts";
import { BaseCacheStorageService } from "./base-cache-storage-service";

export class LocalCacheService extends BaseCacheStorageService {

    static $inject = ["$window", "$log", "$q"];

    constructor($window: ng.IWindowService, $log: ng.ILogService, $q: ng.IQService) {
        super("rl_lcs_", $window.localStorage, $log, $q);
    }
}
